export default __webpack_public_path__ + "static/photoshop-text-bg-b7f400dd922f510fdb84b3d9d87ec116.png";